import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=739b1f5c&scoped=true"
import script from "./DepositDialog.vue?vue&type=script&lang=js"
export * from "./DepositDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b1f5c",
  null
  
)

export default component.exports